import React from 'react';
import QueryFilterTableRow from '../containers/QueryFilterTableRow';
import QueryFilterAddRow from './QueryFilterAddRow';

const QueryFiltersTableRows = ({
  category,
  code,
  clause,
  canEdit,
  isEditing,
  queryUUID,
  validationErrors,
}) => {
  const { filters } = clause;
  const existing = filters.filter((f) => !f.isNew);
  const newFilter = filters.find((f) => f.isNew);
  const displayAddFilterRow = canEdit && isEditing && newFilter;

  const rows = existing.map((filter, index) => (
    <QueryFilterTableRow
      key={`query_filters_table_row_${filter.uuid}`}
      first={index === 0}
      category={category}
      code={code}
      queryUUID={queryUUID}
      clauseUUID={clause.uuid}
      filterUUID={filter.uuid}
      dictionaryCode={clause.dictionary.code}
      canEdit={canEdit}
      isEditing={isEditing}
      validationErrors={validationErrors}
    />
  ));

  if (displayAddFilterRow) {
    rows.push(
      <QueryFilterAddRow
        key={`query_filters_add_row_${newFilter.uuid}`}
        category={category}
        code={code}
        queryUUID={queryUUID}
        clauseUUID={clause.uuid}
        filterUUID={newFilter.uuid}
        dictionaryCode={clause.dictionary.code}
        first={rows.length === 0}
      />,
    );
  }

  return (rows);
};

export default QueryFiltersTableRows;
